import Cookies from "js-cookie";

import SignIn from "./auth/sign-in";
import Dashboard from "./dashboard";

export default function Home() {
  const isAuthenticated = !!Cookies.get("token");
  return isAuthenticated ? <Dashboard /> : <SignIn />;
}
